// Copyright © 2026 Gian Marco Cappelli — SAPIENS (finsapiens.it). Tutti i diritti riservati. Sviluppato su commissione esclusiva. Vietata la riproduzione senza autorizzazione scritta.
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { EducBox, ResultCard, InputRow, PremiumLock, EDUC, fmt } from './shared';

const SurrogaCalc = () => {
  const [importo, setImporto] = useState('150000');
  const [tassoVecchio, setTassoVecchio] = useState('4.5');
  const [tassoNuovo, setTassoNuovo] = useState('3.0');
  const [durataResidua, setDurataResidua] = useState('20');

  const P = parseFloat(importo) || 0;
  const r1 = parseFloat(tassoVecchio) / 100 / 12;
  const r2 = parseFloat(tassoNuovo) / 100 / 12;
  const n = parseInt(durataResidua) * 12;
  const rata1 = r1 > 0 ? P * (r1 * Math.pow(1 + r1, n)) / (Math.pow(1 + r1, n) - 1) : P / n;
  const rata2 = r2 > 0 ? P * (r2 * Math.pow(1 + r2, n)) / (Math.pow(1 + r2, n) - 1) : P / n;
  const risparmioMensile = rata1 - rata2;
  const risparmioTotale = risparmioMensile * n;

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} style={{ position: 'relative' }}>
      <EducBox text={EDUC.surroga} />
      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <InputRow label="Debito residuo (€)" value={importo} onChange={setImporto} prefix="€" />
        <InputRow label="Durata residua (anni)" value={durataResidua} onChange={setDurataResidua} suffix="anni" />
        <InputRow label="Tasso attuale (%)" value={tassoVecchio} onChange={setTassoVecchio} suffix="%" />
        <InputRow label="Nuovo tasso offerto (%)" value={tassoNuovo} onChange={setTassoNuovo} suffix="%" />
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <ResultCard label="Rata attuale" value={`€${fmt(rata1)}`} />
        <ResultCard label="Nuova rata" value={`€${fmt(rata2)}`} green />
        <ResultCard label="Risparmio mensile" value={`€${fmt(risparmioMensile)}`} gold />
        <ResultCard label="Risparmio totale" value={`€${fmt(risparmioTotale)}`} green />
      </div>
      <div style={{ position: 'absolute', inset: 0 }}><PremiumLock /></div>
</motion.div>
  );
};

export default SurrogaCalc;
